<!-- right side of global navbar contains the help, bell and user logged in icons
component used in GlobalNav.vue and NotificationDrawer.vue
-->
<template>
  <div>
    <!-- <v-btn
      icon
      text
      tile
      :ripple="false"
      @click="openFreshworksWidget"
      class="mr-2 noti-icon"
    >
      <v-icon size="32" class="noti-badge-icon">help</v-icon>
    </v-btn> -->
    <v-btn
      icon
      text
      tile
      :ripple="false"
      class="mr-4 noti-icon"
      @click="openNotificationDrawer('notification')"
      v-if="showNotification"
      :data-test-id="`${parentDataTestId}__navbar__notification-bell-icon`"
    >
      <v-badge right overlap v-model="showCount">
        <span slot="badge">{{ unreadNotificationCount }}</span>
        <v-icon size="32" class="noti-badge-icon">notifications_none</v-icon>
      </v-badge>
    </v-btn>

    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" class="mr-0" data-test-id="navbar__user-avatar-btn">
          <v-avatar :size="36" color="#58e2c2">
            <span class="white--text subheading">{{ userNameInitials }}</span>
          </v-avatar>
        </v-btn>
      </template>
      <v-list data-test-id="navbar__avatar-dropdown">
        <v-list-item link data-test-id="navbar__avatar-dropdown__account-settings" @click.stop="openDetailDialog">
          <v-list-item-title class="user-mail">
            {{ userData.name }}
            <small class="d-block">({{ userData.email }})</small>
          </v-list-item-title>
        </v-list-item>
        <!-- <v-list-item link to="/account-settings">
          <v-list-item-title>
            {{
            items[0].title
            }}
          </v-list-item-title>
        </v-list-item> -->
        <!-- <v-list-item link v-if="$can('switch', 'themes')" @click.stop="openSettingsDialog">
          <v-list-item-title>{{ items[1].title }}</v-list-item-title>
        </v-list-item> -->
        <v-list-item link data-test-id="navbar__avatar-dropdown__sessions" @click.stop="openDetailDialog(3)">
          <v-list-item-title>{{ items[2].title }}</v-list-item-title>
        </v-list-item>
        <v-list-item link data-test-id="navbar__avatar-dropdown__logout" @click="userLogout">
          <v-list-item-title>{{ items[3].title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <SettingsDialog
      :dialog="dialog"
      @updateDialog="closeDialog"
    ></SettingsDialog>
    <UserDetailDialog
      v-if="showDetailUserOverlay"
      :userDetailDialog="showDetailUserOverlay"
      :currentTab="profileCurrentTab"
      :userDetails="userDetails"
      @closeOverlay="closeOverlay"
    />
  </div>
</template>

<script>
import SettingsDialog from './SettingsDialog';
import UserDetailDialog from './UserDetailDialog/index';
import { mapMutations, mapState } from 'vuex';
import UserService from '@/services/UserService';
export default {
  components: {
    SettingsDialog,
    UserDetailDialog
  },
  props: {
    showNotification: { type: Boolean, default: true },
    parentDataTestId: String
  },
  computed: {
    ...mapState({
      unreadNotificationCount: state => state.notifications.unreadCount ?? 0,
      isNotificationDrawerOpen: state => state.isNotificationDrawerOpen ?? {}
    }),
    // show count of unread message if any
    showCount() {
      return this.unreadNotificationCount > 0;
    }
  },
  data() {
    return {
      dialog: false,
      userData: {},
      userNameInitials: '',
      profileCurrentTab: 0,
      items: [
        { title: 'Account Settings' },
        {
          title: 'Settings'
        },
        { title: 'Sessions' },
        {
          title: 'Log Out'
        }
      ],
      showDetailUserOverlay: false
    };
  },
  methods: {
    ...mapMutations(['setNotificationDrawer']),
    ...mapMutations('discovery', ['setOpenProjects']),
    /**
     * open profile detail dialog
     * @param {Number} currentTab
     */
    openDetailDialog(currentTab) {
      this.getUserDetails();
      this.profileCurrentTab = currentTab || 0;
    },
    // close detail dialog
    closeOverlay() {
      this.showDetailUserOverlay = false;
    },
    // get user details
    async getUserDetails() {
      let userId = localStorage.getItem('userId');
      let userDetails = await UserService.userDetails(userId);
      if (!userDetails || !(userDetails && userDetails.data)) {
        return false;
      }
      if (!userDetails.data.body.length) {
        return false;
      }
      this.userDetails = userDetails.data.body[0].user;
      this.showDetailUserOverlay = true;
    },
    /**
     * to close dialog
     * @param {Boolean} data
     */
    closeDialog(data) {
      this.dialog = data;
    },
    // open settings
    openSettingsDialog() {
      this.dialog = true;
    },
    openNotificationDrawer(type) {
      const {
        type: drawerType,
        state: drawerState
      } = this.isNotificationDrawerOpen;

      if (drawerType === type) {
        this.setNotificationDrawer({
          state: !drawerState,
          type
        });
      } else {
        this.setNotificationDrawer({
          state: true,
          type
        });
      }
    },
    // get logged in user data
    getUserData() {
      this.userData = JSON.parse(localStorage.getItem('userData'));
      this.userNameInitials = this.getUserNameInitials(this.userData.name);
    },
    // log out from xift
    userLogout() {
      // from mixin
      this.logoutUser();
    }
  },
  created() {
    this.getUserData();
  }
};
</script>

<style scoped>
.noti-icon::before {
  background-color: transparent !important;
}
.noti-badge-icon {
  opacity: 0.54 !important;
  color: #1b2342 !important;
}
.v-badge__badge span {
  color: #fff;
}
</style>
